import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";

const icon1 = require("./../../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../../assets/img/info-icon.svg").default;
const icon3 = require("./../../assets/img/app-icon.svg").default;
const icon4 = require("./../../assets/img/payment-icon.svg").default;
const icon5 = require("./../../assets/img/store-icon.svg").default;
const icon6 = require("./../../assets/img/list-icon.svg").default;
const icon7 = require("./../../assets/img/order-icon.svg").default;
const icon8 = require("./../../assets/img/plan-icon.svg").default;
const icon9 = require("./../../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../../assets/img/delete-icon.svg").default;

const EVENT_CATEGORY_OPTIONS = [
  { value: "Order", labelKey: "eventcategoryorder" },
  { value: "Fair", labelKey: "eventcategoryfair" },
  { value: "Shows", labelKey: "eventcategoryshows" },
  { value: "Open Sunday", labelKey: "eventcategoryopensunday" },
  { value: "Open day", labelKey: "eventcategoryopenday" },
];

const EditEvents = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const { id } = useParams();
  const coverImageBtnRef = useRef();

  const [addFormData, setAddFormData] = useState({
    title: "",
    description: "",
    start_date: "",
    end_date: "",
    location: "",
    category: "",
  });
  const [signupStatus, setSignupStatus] = useState("");
  const [uploadFrontImage, setUploadFrontImage] = useState();
  const [loading, setLoading] = useState();
  const [addBtnDis, setAddBtnDis] = useState();
  const [coverImagePath, setCoverImagePath] = useState(null);

  const inputToMysql = (value) => {
    return value.replace("T", " ") + ":00";
  };

  const mysqlToInput = (value) => {
    if (!value) return "";
    return value.replace(" ", "T").slice(0, 16);
  };

  const handleChange = event => {
    const { name, value } = event.target;

    setAddFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onImageFrontUploadChange = e => {
    const allowedExtensions = ["jpg", "jpeg", "png"];
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadFrontImage(file);
        setSignupStatus("");
      } else {
        setUploadFrontImage(null);
        setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
      }
    }
  };

  const fetchEventDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/admin/events/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAddFormData({
          title: responseData.data.title,
          description: responseData.data.description,
          start_date: mysqlToInput(responseData.data.start_date),
          end_date: mysqlToInput(responseData.data.end_date),
          location: responseData.data.location,
          category: responseData?.data?.category || responseData?.data?.event_category || "",
        });
        setCoverImagePath(responseData?.data?.image || null);
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const onPostArticle = async () => {
    if (addFormData.title === null || addFormData.title === undefined || addFormData.title === "") {
      setSignupStatus(langJson?.titleisrequired);
    } else if (addFormData.start_date === null || addFormData.start_date === undefined || addFormData.start_date === "") {
      setSignupStatus(langJson?.eventstartdateisrequired);
    } else if (addFormData.end_date === null || addFormData.end_date === undefined || addFormData.end_date === "") {
      setSignupStatus(langJson?.eventenddateisrequired);
    } else if (addFormData.description === null || addFormData.description === undefined || addFormData.description === "") {
      setSignupStatus(langJson?.descriptionisrequired);
    }
    else if (!uploadFrontImage && !coverImagePath) {
      setSignupStatus(langJson?.pleaseselectcoverimage);
    }
    else {
      setAddBtnDis(true);
      setSignupStatus("");
      const fd = new FormData();

      if (uploadFrontImage instanceof File) {
        fd.append("image", uploadFrontImage);
      }

      fd.append("title", addFormData.title);
      fd.append("start_date", inputToMysql(addFormData.start_date));
      fd.append("end_date", inputToMysql(addFormData.end_date));
      fd.append("description", addFormData.description);
      fd.append("location", addFormData.location);
      fd.append("category", addFormData.category);
      fd.append("lang", selectedLanguage);
      try {
        const response = await fetch(`${API_BASE_URL}stores/admin/events/${id}`, {
          method: "POST",
          body: fd,
          headers: {
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          setSignupStatus(responseData.msg);
          setLoading(false);
          setAddBtnDis(false);
        } else {
          setSignupStatus(responseData.msg);
          setLoading(false);
          setAddBtnDis(false);
        }
      } catch (error) {
        console.error("Error during Sign UP:", error);
        setLoading(false);
        setAddBtnDis(false);
      }
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  useEffect(() => {
    setAddFormData({
      title: null,
      description: null,
      start_date_time: null,
      location: null,
      category: "",
    });
    setUploadFrontImage(null);
    fetchEventDetails();
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide">
          <h2>
            {langJson?.edit} {langJson?.event}
          </h2>
          <ul className="addAddress">
            <li className="fullWidth">
              <label>{langJson?.title}</label>
              <input type="text" name="title" onChange={handleChange} value={addFormData.title} />
            </li>
            <li>
              <label>{langJson?.eventstartdate}</label>
              <input
                type="datetime-local"
                name="start_date"
                onChange={handleChange}
                value={addFormData.start_date}
                min={getCurrentDateTime()}
              />
            </li>

            <li>
              <label>{langJson?.eventenddate}</label>
              <input
                type="datetime-local"
                name="end_date"
                onChange={handleChange}
                value={addFormData.end_date}
                min={addFormData.start_date || getCurrentDateTime()}
              />
            </li>

            <li className="fullWidth">
              <label>{langJson?.description}</label>
              <textarea name="description" value={addFormData.description} onChange={handleChange}></textarea>
            </li>
            <li>
              <label>{langJson?.location}</label>
              <input type="text" name="location" onChange={handleChange} value={addFormData.location} />
            </li>
            <li>
              <label>{langJson?.category || "Category"}</label>
              <select name="category" onChange={handleChange} value={addFormData.category || ""}>
                <option value="">{langJson?.category || "Category"}</option>
                {EVENT_CATEGORY_OPTIONS.map(category => (
                  <option key={category.value} value={category.value}>
                    {langJson?.[category.labelKey] || category.value}
                  </option>
                ))}
              </select>
            </li>
            <li className="fullWidth">
              <label>{langJson?.uploadcoverimage}:</label>
              {!uploadFrontImage ? (
                <>
                  <input type="file" ref={coverImageBtnRef} hidden onChange={e => onImageFrontUploadChange(e)} />
                  <button onClick={() => coverImageBtnRef.current.click()}>{langJson?.choosecoverimage}</button>
                  {coverImagePath ? (
                    <div className="coverPreviewWrap">
                      <img className="coverPreviewImg" src={IMAGE_URL + coverImagePath} />
                      <img className="coverPreviewDelete" src={deleteIcon} alt="" onClick={() => setCoverImagePath(null)} />
                    </div>
                  ) : null}
                </>
              ) : (
                <div className="coverPreviewWrap">
                  <img className="coverPreviewImg" src={URL.createObjectURL(uploadFrontImage)} />
                  <img className="coverPreviewDelete" src={deleteIcon} alt="" onClick={() => setUploadFrontImage(null)} />
                </div>
              )}
            </li>

            <li className="fullWidth saveBtn">
              <button type="button" disabled={addBtnDis} onClick={() => onPostArticle()}>
                {addBtnDis ? langJson?.pleasewait : langJson?.savechanges}
              </button>
              <Link className="backLink" to="/admin/events">{langJson?.back ?? "Back"}</Link>
            </li>
            <span className="lgnStatus">{signupStatus}</span>
          </ul>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default EditEvents;
